import Permissioned from 'dashboard/components/Permissioned';
import { ReportCustomList } from 'dashboard/models/report/custom-list';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { Permission } from 'lib/permissions';

export const CustomList = ({
  report,
  isRedacted,
}: {
  report: ReportCustomList;
  isRedacted: boolean;
}) => {
  const query = report?.attributes.query ?? {};
  const filteredKeys = Object.keys(query).reduce((result, current) => {
    if (query[current]) {
      result.push(current);
    }
    return result;
  }, [] as string[]);

  return (
    <>
      <AttributeGrid>
        {filteredKeys.map((key) => {
          if (key === 'social-security-number') {
            return (
              <Permissioned
                key={key}
                permission={Permission.ReportSsnView}
                fallback={
                  <Attribute
                    label={KEY_TO_LABEL[key] ?? key}
                    value={query[key]?.substring(query[key].length - 4)}
                    toggleable={true}
                    redacted={isRedacted}
                    placeholder='-'
                  />
                }
              >
                <Attribute
                  label={KEY_TO_LABEL[key] ?? ''}
                  value={query[key]}
                  toggleable={true}
                  redacted={isRedacted}
                  placeholder='-'
                />
              </Permissioned>
            );
          }

          return (
            <Attribute
              key={key}
              label={KEY_TO_LABEL[key] ?? ''}
              value={query[key]}
              redacted={isRedacted}
              placeholder='-'
            />
          );
        })}
      </AttributeGrid>
      {filteredKeys.length <= 0 && 'No input found'}
    </>
  );
};

const KEY_TO_LABEL: Record<string, string> = {
  'name-first': 'First Name',
  'name-middle': 'Middle Name',
  'name-last': 'Last Name',
  'name-suffix': 'Suffix',
  'name-full': 'Full Name',
  'name-alias-first': 'First Name (Alias)',
  'name-alias-middle': 'Middle Name (Alias)',
  'name-alias-last': 'Last Name (Alias)',
  'name-alias-suffix': 'Suffix (Alias)',
  sex: 'Sex',
  'phone-number': 'Phone Number',
  'address-street-1': 'Address Street 1',
  'address-street-2': 'Address Street 2',
  'address-city': 'City',
  'address-subdivision': 'Subdivision',
  'address-postal-code': 'Postal Code',
  'address-country-code': 'Country Code',
  'address-full': 'Address (Full)',
  'business-name': 'Business Name',
  business_dba: 'Business DBA',
  'incorporation-date': 'Incorporation Date',
  'identification-number': 'Identification Number',
  'identification-number-type': 'Identification Number Type',
  passport: 'Passport',
  birthdate: 'Birthdate',
  'drivers-license': 'Drivers License',
  'alien-registration': 'Alien Registration',
  'social-security-number': 'Social Security Number',
  'employer-identification-number': 'Employer Identification Number',
  'taxpayer-identification-number': 'Taxpayer Identification Number',
  'email-address': 'Email',
};
